var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M51.8072 50.8763C51.9307 50.9998 52 51.1672 52 51.3418C52 51.5163 51.9307 51.6838 51.8072 51.8072C51.6838 51.9307 51.5163 52 51.3418 52C51.1672 52 50.9998 51.9307 50.8763 51.8072L39.5 40.4309L28.1237 51.8072C28.0002 51.9307 27.8328 52 27.6582 52C27.4837 52 27.3162 51.9307 27.1928 51.8072C27.0694 51.6838 27 51.5163 27 51.3418C27 51.1672 27.0693 50.9998 27.1928 50.8763L38.5691 39.5L27.1928 28.1237C27.0693 28.0002 27 27.8328 27 27.6582C27 27.4837 27.0693 27.3162 27.1928 27.1928C27.3162 27.0693 27.4837 27 27.6582 27C27.8328 27 28.0002 27.0693 28.1237 27.1928L39.5 38.5691L50.8763 27.1928C50.9374 27.1317 51.01 27.0832 51.0899 27.0501C51.1697 27.017 51.2553 27 51.3418 27C51.4282 27 51.5138 27.017 51.5937 27.0501C51.6735 27.0832 51.7461 27.1317 51.8072 27.1928C51.8683 27.2539 51.9168 27.3265 51.9499 27.4063C51.983 27.4862 52 27.5718 52 27.6582C52 27.7447 51.983 27.8303 51.9499 27.9101C51.9168 27.99 51.8683 28.0626 51.8072 28.1237L40.4309 39.5L51.8072 50.8763Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInt);
export default __webpack_public_path__ + "static/media/int.fd140453e236bd0a29ecd23349355566.svg";
export { ForwardRef as ReactComponent };